<template>
  <div class="container">
    <div class="header"><img :src="$store.state.config.header" class="img"></div>
    <div class="content">
      <div class="main-body">
        <!-- <div class="top-bar" :style="{backgroundColor:$store.state.config.title_color}">{{title}}</div> -->
        <ul class="menu-list">
          <li class="menu-item">
            <router-link class="back-btn" :to="{path: '/', query: {tt: $route.query.tt}}">奖项投票<span class="img-icon"></span></router-link>
          </li>
          <li class="menu-item">
            <router-link class="back-btn" :to="{path: '/company', query: {tt: $route.query.tt}}">公司投票<span class="img-icon"></span></router-link>
          </li>
        </ul>
        <div class="main-wrapper">
          <div class="main-content">
            <div class="line-height"><span>&nbsp;</span></div>
            <div class="intro">
              <p v-html="introduction"></p>
            </div>
            <div class="presents-box">
              <div v-if="has_category">
                <div v-for="item in categories">
                  <div class="menu-label">{{item.name}}</div>
                  <ul class="presents-lists">
                    <li class="presents-item" v-for="data in item.rewards">
                      <router-link :to="{path: 'list', query: {reward_id: data.reward_id, tt: $route.query.tt}}">
                        <div class="item-title">{{data.name}}</div>
                        <div class="item-arrow">&nbsp;</div>
                        <div class="clearfix"></div>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
              <div v-else>
                <ul class="presents-lists">
                  <li class="presents-item" v-for="data in rewards">
                    <router-link :to="{path: 'list', query: {reward_id: data.reward_id, tt: $route.query.tt}}">
                      <div class="item-title">{{data.name}}</div>
                      <div class="item-arrow">&nbsp;</div>
                      <div class="clearfix"></div>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div class="footer"><img :src="$store.state.config.footer"></div>
          </div>
        </div>
      </div>
    </div>
    <v-loading v-show="status"></v-loading>
  </div>
</template>

<script>
import {ajax} from 'jquery'

import Load from '@/components/Loading'
import shareInfo from '@/assets/js/weixinShare.js'

export default {
  name: 'HelloWorld',
  components: {
    'v-loading': Load
  },
  data () {
    return {
      status: true, //loading状态
      introduction: '',
      has_category: false,
      title: '',
      rewards:[],
      categories:[]
    }
  },
  created() {
    let that = this;
    
    document.body.scrollTop = 0;
    
    ajax({
      type: 'get',
      url: that.$store.state.Host+'/v/votes/'+that.$route.query.tt,
      success: function(res) {
        that.title = res.title;
        that.introduction = res.introduction;
        that.has_category = res.has_category;
        that.rewards = res.rewards;
        that.categories = res.categories;

        //longding
        that.status = false;
      }
    })

  },
  mounted() {
    let that = this;

    setTimeout(function() {
      // 分享调用
      shareInfo.init({title:that.$store.state.config.title,desc:that.$store.state.config.share_desc,shareURL: location.href,img:that.$store.state.config.share});
    }, 2000);
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Index.vue